import { removeUserTabs } from 'redux/actions/tabs'
import inchatActions from 'redux/inchat/actions'
export const clearReduxExitChannel = (dispatch, conversation, history, toggleOpen, tabs) => {
  const idConversation = conversation._id
  const existInTab = tabs.users.some(user => user.id === idConversation)
  const isActive = tabs.activeUser === idConversation
  dispatch(removeUserTabs(idConversation))
  if(existInTab && isActive){
    history.push(`${history.location.pathname}`)
  }
  setTimeout(() => {
    toggleOpen()
    dispatch(inchatActions.removeConversationChannel(idConversation))
  }, 300)
}